export default {
    styleOverrides: {
        html: {
            // Base mobile font size (for screens smaller than 1280px)
            fontSize: '14px',
            // 720p HD (1280 x 720)
            '@media screen and (min-width: 1280px) and (max-width: 1919px)': {
                fontSize: '15px', // Slightly smaller than default for HD
            },
            // 1080p Full HD (1920 x 1080)
            '@media screen and (min-width: 1920px) and (max-width: 2559px)': {
                fontSize: '16px', // Standard base size
            },
            // 1440p QHD (2560 x 1440)
            '@media screen and (min-width: 2560px) and (max-width: 3839px)': {
                fontSize: '18px', // Larger for QHD
            },
            // 4K UHD (3840 x 2160)
            '@media screen and (min-width: 3840px) and (max-width: 7679px)': {
                fontSize: '22px', // Substantial increase for 4K
            },
            // 8K UHD (7680 x 4320)
            '@media screen and (min-width: 7680px)': {
                fontSize: '28px', // Largest size for 8K
            },
        },
    }
};
